import { initReactI18next } from 'react-i18next';

import i18n from 'i18next';

import { Language } from '../shared/constants';
import {
  LocalStorageKey,
  LocalStorageService,
} from '../shared/storage/local-storage';
import * as by from './by.json';
import * as en from './en.json';
import * as pl from './pl.json';
import * as ru from './ru.json';
import * as ua from './ua.json';

const storageLanguage = LocalStorageService.getValue(LocalStorageKey.language);
const initialLanguage = Object.values(Language).includes(storageLanguage)
  ? storageLanguage
  : Language.en;

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: { ...en },
    },
    ru: {
      translation: { ...ru },
    },
    ua: {
      translation: { ...ua },
    },
    by: {
      translation: { ...by },
    },
    pl: {
      translation: { ...pl },
    },
  },
  lng: initialLanguage,
});
